import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import HeaderBannerPage from "../components/HeaderBannerPage";
import AccumulatedTable from "../components/tables/AccumulatedTbl";
import { fetchProductionAccumulated } from "../actions/ProductionAction";

const Production = () => {
  const dispatch = useDispatch();

  const { Data, loading, error } = useSelector(
      (state) => state.productionAccumulate || {}
  );

  useEffect(() => {
    dispatch(fetchProductionAccumulated());
  }, [dispatch]);

  console.log("Redux state accumulate:", useSelector(state => state.accumulate));

  return (
    <Box sx={{ width: "100%", minHeight: "100vh" }}>
      <HeaderBannerPage />

      <Box sx={{ p: 2 }}>
        {loading && <div>Loading...</div>}
        {error && <div style={{ color: "red" }}>{error}</div>}

        {!loading && !error && (
          <AccumulatedTable rows={Array.isArray(Data) ? Data : []} />
        )}
      </Box>
    </Box>
  );
};

export default Production;